import { ref } from 'vue';
import type { Ref } from 'vue';

type UseScrollbarWidthReturn = {
    scrollbarWidth: Ref<number>;
    hasVerticalScroll: Ref<boolean>;
    updateScrollbarWidth: () => void;
};

const DEFAULT_SCROLLBAR_WIDTH = 17;

export const useScrollbarWidth = (
    wrapperSelector: string = '.v-table__wrapper',
    containerRef: Ref<{ $el: HTMLElement } | null>,
): UseScrollbarWidthReturn => {
    const scrollbarWidth = ref<number>(0);
    const hasVerticalScroll = ref<boolean>(false);

    const updateScrollbarWidth = (): void => {
        if (!containerRef.value) {
            return;
        }

        const container = containerRef.value.$el;
        if (!container) {
            return;
        }

        const wrapper = container.querySelector<HTMLElement>(wrapperSelector);
        if (!wrapper) {
            return;
        }

        const hasScroll = wrapper.scrollHeight > wrapper.clientHeight;
        hasVerticalScroll.value = hasScroll;

        let width = wrapper.offsetWidth - wrapper.clientWidth;

        if (width === 0 && hasScroll) {
            width = DEFAULT_SCROLLBAR_WIDTH;
        }

        scrollbarWidth.value = width;
        wrapper.style.setProperty('--scrollbar-width', `${width}px`);
    };

    return {
        scrollbarWidth,
        hasVerticalScroll,
        updateScrollbarWidth,
    };
};
